import TextareaQuestionSurface from "./TextareaQuestionSurface";

export const SURFACE_13_LABEL = "What's the season they're in right now?";
export const SURFACE_13_HELPER = "Anything big -- good, hard, or both. A new job, a new baby, a hard year, a fresh start. If nothing stands out, skip it.";
export const SURFACE_13_PLACEHOLDER = "What's going on for them right now...";

export default function Surface13(props) {
  return (
    <TextareaQuestionSurface
      current={9}
      label={SURFACE_13_LABEL}
      helper={SURFACE_13_HELPER}
      placeholder={SURFACE_13_PLACEHOLDER}
      name="recipient_season"
      optional
      {...props}
    />
  );
}
